import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Concept from './components/Concept';
import Why from './components/Why';
import Market from './components/Market';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-[#231D17] text-[#F0E1C2]">
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-[#231D17]/95 backdrop-blur-sm shadow-lg' : 'bg-transparent'
        }`}
      >
        <div className="container mx-auto px-6 py-4 flex items-center justify-end">
          <a
            href="#contact"
            className="bg-[#B78A44] text-[#231D17] px-8 py-3 rounded-md font-medium hover:bg-[#E5C478] transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Get in Touch
          </a>
        </div>
      </nav>

      <Hero />
      <Concept />
      <Why />
      <Market />
      <Contact />
      <Footer />
    </div>
  );
}
